import React, { useState } from "react";
import { Link } from 'react-router-dom'
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

function BannerSlider() {
    const [currentSlide, setCurrentSlide] = useState(0);

    const settings = {
        dots: true,
        arrows:false,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        afterChange: (current) => setCurrentSlide(current)
      };
  return (
    <div>
        <div className="banner">
        <Slider {...settings} className="banner_slider">
            <div className="slide-item " >
                <div className="banner_text banner_image" style={{ backgroundImage: 'url(/tm/react/roboto/assets/images/banner/1.jpg)' }}>
                    <div className="container">
                        <div className="text_inner">
                            <p className="subtitle">Robot Creative & Template</p>
                            <h1 className="title">Machinery commerce services of<br /> robot</h1>
                            <Link to="/services" className="thm-btn btn-rounded"><span className="button_title">View More</span></Link>
                        </div>
                    </div>
                </div>
            </div>
            
            <div className="slide-item " >
                <div className="banner_text banner_image" style={{ backgroundImage: 'url(/tm/react/roboto/assets/images/banner/2.jpg)' }}>
                    <div className="container">
                        <div className="text_inner">
                            <p className="subtitle">Robot Creative & Template</p>
                            <h1 className="title">Machinery commerce services of<br /> robot</h1>
                            <Link to="/services" className="thm-btn btn-rounded"><span className="button_title">View More</span></Link>
                        </div>
                    </div>
                </div>
            </div>
           
            <div className="slide-item " >
                <div className="banner_text banner_image" style={{ backgroundImage: 'url(/tm/react/roboto/assets/images/banner/3.jpg)' }}>
                    <div className="container">
                        <div className="text_inner">
                            <p className="subtitle">Robot Creative & Template</p>
                            <h1 className="title">Machinery commerce services of<br /> robot</h1>
                            <Link to="/services" className="thm-btn btn-rounded"><span className="button_title">View More</span></Link>
                        </div>
                    </div>
                </div>
            </div>
           
            <div className="slide-item " >
                <div className="banner_text banner_image" style={{ backgroundImage: 'url(/tm/react/roboto/assets/images/banner/4.jpg)' }}>
                    <div className="container">
                        <div className="text_inner">
                            <p className="subtitle">Robot Creative & Template</p>
                            <h1 className="title">Machinery commerce services of<br /> robot</h1>
                            <Link to="/services" className="thm-btn btn-rounded"><span className="button_title">View More</span></Link>
                        </div>
                    </div>
                </div>
            </div>
            
            <div className="slide-item " >
                <div className="banner_text banner_image" style={{ backgroundImage: 'url(/tm/react/roboto/assets/images/banner/5.jpg)' }}>
                    <div className="container">
                        <div className="text_inner">
                            <p className="subtitle">Robot Creative & Template</p>
                            <h1 className="title">Machinery commerce services of<br /> robot</h1>
                            <Link to="/services" className="thm-btn btn-rounded"><span className="button_title">View More</span></Link>
                        </div>
                    </div>
                </div>
            </div>
           
            <div className="slide-item " >
                <div className="banner_text banner_image" style={{ backgroundImage: 'url(/tm/react/roboto/assets/images/banner/6.jpg)' }}>
                    <div className="container">
                        <div className="text_inner">
                            <p className="subtitle">Robot Creative & Template</p>
                            <h1 className="title">Machinery commerce services of<br /> robot</h1>
                            <Link to="/services" className="thm-btn btn-rounded"><span className="button_title">View More</span></Link>
                        </div>
                    </div>
                </div>
            </div>
        </Slider>
        <div className="container">
            <div className="row">
                <div className="col-12">
                    <div className="dots_counts">
                    <div className="current-slide slider-count"><span className="current">{currentSlide + 1}</span><small>/6</small></div>
                        {/* <div className="slider-count"><span className="current">01</span><small>/6</small></div>
                        <div className="slick-slider-dots"></div> */}
                    </div>
                </div>
            </div>
        </div>
    </div>
    </div>
  )
}

export default BannerSlider